import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, withModifiers as _withModifiers, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d68cee6")

_pushScopeId("data-v-2d68cee6")
const _hoisted_1 = { class: "block text-sm font-normal text-neutrals-900 font-medium" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("dqwdw")
const _hoisted_3 = {
  key: 0,
  class: "inset-y-0 ml-12p mr-8p flex items-center text-neutrals-500"
}
const _hoisted_4 = {
  key: 2,
  class: "inset-y-0 right-0 ml-8p mr-4p flex items-center w-8p"
}
const _hoisted_5 = {
  key: 4,
  class: "absolute ml-8p inset-y-0 right-0 pr-2p flex items-center"
}
const _hoisted_6 = {
  key: 0,
  class: "input__suffix-password inset-y-0 right-0 mx-8p flex items-center w-8p"
}
const _hoisted_7 = {
  key: 3,
  class: "inset-y-0 flex items-center text-neutrals-500 w-100%"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-4p text-14 text-left flex"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_component = _resolveComponent("icon-component")
  const _component_stepper = _resolveComponent("stepper")
  const _component_tooltip_component = _resolveComponent("tooltip-component")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: ["flex justify-between", {'mb-4p': _ctx.$slots.label}]
    }, [
      _createVNode("label", _hoisted_1, _toDisplayString(_ctx.label), 1),
      (_ctx.$slots.optional)
        ? _renderSlot(_ctx.$slots, "optional", { key: 0 }, () => [
            _hoisted_2
          ], {}, true)
        : _createCommentVNode("", true)
    ], 2),
    _createVNode("div", {
      class: [_ctx.classInputContainer, "input-comp text-14 arrow-off relative rounded-4p flex border transition"],
      style: [
                {
                    flexWrap: _ctx.$slots.selectedItem ? 'wrap' : '',
                },
            ]
    }, [
      (_ctx.$slots.prefix)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "prefix", {}, undefined, true)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: ["relative w-fill", {
                    'pl-12p': !_ctx.$slots.prefix,
                    'pr-12p': !_ctx.counter && !_ctx.$slots.suffix && !(_ctx.closeIcon && _ctx.valueSync && _ctx.type !== 'number'),
                }],
        style: [
                    {
                        flex: _ctx.$slots.selectedItem ? '1' : '',
                    },
                ]
      }, [
        (_ctx.textarea)
          ? _withDirectives((_openBlock(), _createBlock("textarea", {
              key: 0,
              ref: "textfieldComp",
              type: _ctx.type === 'password' ? _ctx.passwordType : _ctx.type,
              class: [_ctx.classInput, "\r\n                            neutrals-900\r\n                            transition-all\r\n                            ring\r\n                            py-7p\r\n                            pl-0\r\n                            block\r\n                            w-full\r\n                            focus:outline-none\r\n                            sm:text-sm\r\n                            resize-none\r\n                        "],
              placeholder: _ctx.placeholder,
              "aria-invalid": "true",
              maxlength: _ctx.maxlength,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.valueSync = $event)),
              disabled: _ctx.disabled,
              autocomplete: _ctx.type === 'password' ? 'on' : 'off',
              style: { height: _ctx.heightTextarea + 'px' }
            }, null, 14, ["type", "placeholder", "maxlength", "disabled", "autocomplete"])), [
              [_vModelText, _ctx.valueSync]
            ])
          : _withDirectives((_openBlock(), _createBlock("input", {
              key: 1,
              ref: "textfieldComp",
              type: _ctx.type === 'password' ? _ctx.passwordType : _ctx.type,
              class: [_ctx.classInput, "testne neutrals-900 transition-all ring py-7p pl-0 block w-full focus:outline-none sm:text-sm"],
              placeholder: _ctx.placeholder,
              "aria-invalid": "true",
              maxlength: _ctx.maxlength,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.valueSync = $event)),
              disabled: _ctx.disabled,
              autocomplete: _ctx.type === 'password' ? 'on' : 'new-input'
            }, null, 10, ["type", "placeholder", "maxlength", "disabled", "autocomplete"])), [
              [_vModelDynamic, _ctx.valueSync]
            ])
      ], 6),
      (_ctx.type !== 'password')
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (_ctx.counter && _ctx.inputModalTag)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["inset-y-0 right-0 ml-8p flex items-center", (_ctx.closeIcon && _ctx.valueSync && _ctx.type !== 'number') || _ctx.$slots.suffix ? 'mr-12p' : 'mr-12p']
                }, [
                  (_ctx.counter && _ctx.type !== 'number')
                    ? (_openBlock(), _createBlock("span", {
                        key: 0,
                        class: [_ctx.disabled ? 'text-neutrals-300' : 'text-neutrals-500', _ctx.textarea ? 'h-full pt-8p' : '']
                      }, _toDisplayString(_ctx.countItem) + "/10 ", 3))
                    : _createCommentVNode("", true)
                ], 2))
              : (_ctx.counter)
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: ["inset-y-0 right-0 ml-8p flex items-center", (_ctx.closeIcon && _ctx.valueSync && _ctx.type !== 'number') || _ctx.$slots.suffix ? 'mr-8p' : 'mr-12p']
                  }, [
                    (_ctx.counter && _ctx.type !== 'number')
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          class: [_ctx.disabled ? 'text-neutrals-300' : 'text-neutrals-500', _ctx.textarea ? 'h-full pt-8p' : '']
                        }, _toDisplayString(`${_ctx.valueSync.length}/${_ctx.maxlength}`), 3))
                      : _createCommentVNode("", true)
                  ], 2))
                : (_ctx.closeIcon && _ctx.valueSync && _ctx.type !== 'number')
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createVNode(_component_icon_component, {
                        class: "cursor-pointer",
                        onClick: _withModifiers(_ctx.onClearText, ["stop","prevent"]),
                        name: "times"
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
            (_ctx.$slots.suffix)
              ? (_openBlock(), _createBlock("div", {
                  key: 3,
                  class: [(_ctx.closeIcon && _ctx.valueSync && _ctx.type !== 'number') || _ctx.counter ? 'mr-8p' : 'mr-12p', "inset-y-0 ml-8p flex items-center text-neutrals-500"]
                }, [
                  (_ctx.$slots.suffix)
                    ? _renderSlot(_ctx.$slots, "suffix", { key: 0 }, undefined, true)
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.type === 'number' && !_ctx.$slots.suffix)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  (_ctx.stepper)
                    ? (_openBlock(), _createBlock(_component_stepper, {
                        key: 0,
                        onPressed: _ctx.onPressed,
                        disabled: _ctx.disabled,
                        disabledUp: _ctx.disabledUp,
                        disabledDown: _ctx.disabledDown
                      }, null, 8, ["onPressed", "disabled", "disabledUp", "disabledDown"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            (_ctx.valueSync)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode(_component_tooltip_component, {
                    type: "light",
                    content: !_ctx.isShowPassword ? 'Show' : 'Hide'
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_icon_component, {
                        class: "cursor-pointer",
                        onClick: _cache[3] || (_cache[3] = () => (_ctx.isShowPassword = !_ctx.isShowPassword)),
                        name: !_ctx.isShowPassword ? 'eye' : 'eye-slash',
                        color: _ctx.disabled ? 'neutrals-300' : ''
                      }, null, 8, ["name", "color"])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ]))
              : _createCommentVNode("", true)
          ], 64)),
      (_ctx.$slots.selectedItem)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "selectedItem", {}, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ], 6),
    (_ctx.$slots.hint)
      ? (_openBlock(), _createBlock("p", _hoisted_8, [
          _renderSlot(_ctx.$slots, "hint", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
})